<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">อัตราค่าบริการ (Parking Rate)</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">ตั้งค่า rate_id / เวลาฟรี / Taiwan discount · fine ตามลานจอดรถ</p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
      <div *ngIf="lastFetchedTime"
        class="flex flex-col items-end justify-center text-right shrink-0 w-[112px] h-[46px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()" title="รีเฟรชข้อมูล"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center cursor-pointer">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" type="button" (click)="openCreate()"
        class="px-5 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer">
        <span class="material-icons text-[18px]">add</span> เพิ่มอัตรา
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <div>
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">payments</span>รายการอัตราค่าบริการ
        </h3>
        <span *ngIf="siteState.selectedSite()?.name"
          class="inline-flex items-center gap-1 mt-2 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold">
          <span class="material-icons text-[14px]">local_parking</span>{{ siteState.selectedSite()?.name }}
        </span>
      </div>
      <div class="relative w-full lg:max-w-md">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
        <input type="text" [ngModel]="searchText()" (ngModelChange)="searchText.set($event); onSearchChange()"
          placeholder="ค้นหา rate_id / ชื่อ / detail..."
          class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none" />
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <app-pss-loading *ngIf="isLoading()"></app-pss-loading>
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()" [class.pointer-events-none]="isLoading()">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">ID</th>
            <th class="p-4">Rate ID</th>
            <th class="p-4">ชื่อ</th>
            <th class="p-4 text-center">Free time</th>
            <th class="p-4">Taiwan discount</th>
            <th class="p-4">Taiwan fine</th>
            <th class="p-4 text-center">Discount</th>
            <th class="p-4">แก้ไขล่าสุด</th>
            <th class="p-4 text-center w-[100px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let item of items(); trackBy: trackById"
            class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 transition-all">
            <td class="p-4 font-mono font-bold text-slate-400">{{ item.id }}</td>
            <td class="p-4">
              <span class="px-2.5 py-1 rounded-lg bg-sky-50 dark:bg-sky-900/20 text-sky-600 dark:text-sky-400 text-xs font-bold font-mono">
                {{ item.rateId || '—' }}
              </span>
            </td>
            <td class="p-4">
              <div class="font-bold text-slate-700 dark:text-slate-200">{{ item.name || '—' }}</div>
              <div class="text-[11px] text-slate-400 max-w-xs truncate" *ngIf="item.detail" [title]="item.detail">{{ item.detail }}</div>
            </td>
            <td class="p-4 text-center">
              <span class="inline-flex min-w-[2.5rem] justify-center px-2.5 py-1 rounded-full text-xs font-bold bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400">
                {{ item.freeTime != null ? item.freeTime : '—' }}
              </span>
            </td>
            <td class="p-4 text-sm font-medium text-slate-600 dark:text-slate-300">
              <ng-container *ngIf="!item.splitByVehicleType; else splitDiscount">
                {{ item.taiwanDiscountName || '—' }}
              </ng-container>
              <ng-template #splitDiscount>
                <span class="inline-flex items-center gap-1 mb-1 px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400 text-[10px] font-bold">
                  <span class="material-icons text-[12px]">call_split</span>แยกประเภทรถ
                </span>
                <div class="text-xs"><span class="text-slate-400">ประเภท 1:</span> {{ item.taiwanDiscountName || '—' }}</div>
                <div class="text-xs"><span class="text-slate-400">ประเภท 2:</span> {{ item.taiwanDiscountName2 || '—' }}</div>
              </ng-template>
            </td>
            <td class="p-4 text-sm font-medium text-slate-600 dark:text-slate-300">
              <ng-container *ngIf="!item.splitByVehicleType; else splitFine">
                <span *ngIf="item.taiwanFineName; else noFine">{{ item.taiwanFineName }}</span>
                <ng-template #noFine>
                  <span class="text-slate-400">{{ item.taiwanFineId != null ? ('#' + item.taiwanFineId) : '—' }}</span>
                </ng-template>
              </ng-container>
              <ng-template #splitFine>
                <div class="text-xs"><span class="text-slate-400">ประเภท 1:</span> {{ item.taiwanFineName || '—' }}</div>
                <div class="text-xs"><span class="text-slate-400">ประเภท 2:</span> {{ item.taiwanFineName2 || '—' }}</div>
              </ng-template>
            </td>
            <td class="p-4 text-center">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold"
                [ngClass]="item.discount ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' : 'bg-slate-100 text-slate-400'">
                {{ item.discount ? 'Yes' : 'No' }}
              </span>
            </td>
            <td class="p-4 text-xs text-slate-500 whitespace-nowrap">
              {{ item.updateDate | date:'dd/MM/yyyy HH:mm':'':'en-GB' }}
            </td>
            <td class="p-4 text-center">
              <button *ngIf="canUpdate" type="button" (click)="openEdit(item)" title="แก้ไข"
                class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-amber-400 hover:text-amber-500 transition-all cursor-pointer">
                <span class="material-icons text-base">edit</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="!selectedSiteId && !isLoading()">
            <td colspan="9" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 opacity-40 block">location_off</span>
              <p class="font-bold">กรุณาเลือกลานจาก Sidebar</p>
            </td>
          </tr>
          <tr *ngIf="selectedSiteId && !isLoading() && items().length === 0">
            <td colspan="9" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 opacity-40 block">search_off</span>
              <p class="font-bold">ไม่พบข้อมูลอัตราค่าบริการ</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button type="button" *ngFor="let page of pagesArray" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all cursor-pointer"
          [ngClass]="page === currentPage() ? 'bg-amber-400 text-white shadow-sm' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
          {{ page }}
        </button>
        <button type="button" (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-parking-rate *ngIf="isModalOpen()" [itemId]="selectedId()" [siteId]="selectedSiteId"
  [siteName]="selectedSiteName" (close)="closeModal()" (saveSuccess)="closeModal(); loadTable()">
</app-modal-parking-rate>
